<template>
  <v-card class="mx-auto" variant="flat" max-width="300">
    <!-- <v-list>
      <v-list-item>
        <router-link class="" to="/home">
          <v-img class="mt-4" src="@/assets/img/logo_color.png" height="70" contain></v-img>
        </router-link>
      </v-list-item>
    </v-list>
    <v-divider class="my-2"></v-divider> -->
    <v-list :lines="false" density="compact" nav>
      <v-list-item
        v-for="item in menuItems"
        :key="item.path" 
        :active="isRouteActive(item.path)"
        link
        @click="selected=item"
        :to="{ name: item.path }"
        color="primary"
        variant="text"
        lines="two"
        density="compact"
        :border="true">
        <template v-slot:[`prepend`]>
          <v-icon :icon="item.icon"></v-icon>
        </template>
        <v-list-item-title class="custom-text-item-size">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { roleManager } from '@/store/roleManager';
import { mapGetters } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      menuItems: [
        { title: 'HOME', path: 'HomeView', icon: 'mdi-home' },
      ],
      particlesOptions: {
        particles: {
          number: {
            value: 80,
          },
          size: {
            value: 3,
          },
          move: {
            enable: true,
            speed: 3,
          },
          opacity: {
            value: 0.5,
          },
          line_linked: {
            enable: true,
            distance: 150,
          },
        },
      }

    };
  },
  mounted() {
    this.controlPanelTab();
  },
  methods: {
    controlPanelTab() {
      if (roleManager.isAnyAdmin()) {
        this.menuItems.push(
          { title: 'REPOSITORY', path: 'DocumentList', icon: 'mdi-file-document' },
          { title: 'ADMIN', path: 'AdminView', icon: 'mdi-account-supervisor' },
          { title: 'USER TRAIL', path: 'AuditUsers', icon: 'mdi-account-clock' },
          { title: 'FILE TRAIL', path: 'AuditDocuments', icon: 'mdi-file-document' }
        );
      }
      if (roleManager.isUploader() || roleManager.isVerifier() || roleManager.isResearcher()) {
        this.menuItems.push(
          { title: 'REPOSITORY', path: 'DocumentList', icon: 'mdi-file-document' },
        );
      }
      if (roleManager.isStaff()) {
        this.menuItems.push(
          { title: 'EVENT TRAIL', path: 'AuditEvents', icon: 'mdi-transit-connection-variant' },
        );
      }
    },
    isRouteActive(path) {
      return this.activeRoute === this.$router.resolve({name: path}).fullPath;
    }
  },
  computed: {
    ...mapGetters(['activeRoute']),
  }
};
</script>

<style scoped lang="scss">
  .logo {
    margin-top: 0;
  }
  .align-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-text-item-size {
    font-size: 1em;
    font-weight: 600;
  }
  .v-list.v-list--nav > a.v-list-item {
     &.v-list-item--active {
       border-color: var(--v-primary-primary);
     }
     &:not(.v-list-item--active) {
      border: none;
     }
  }
</style>
